<template>
  <div class="swiper-container swipersBox"
    :id="'swiper' + awardIndex">
    <div class="swiper-wrapper">
      <div class="swiper-slide part3_mess_pre"
        v-for="(item, index) in awardList"
        :key="index">
        <p class="pre_part3_tit" :class="'pre_part3_tit' + skinNum">{{ item.awardName }} {{item.awardNumber?item.awardNumber:'若干'}} <span>名</span> </p>
        <p class="pre_part3_me" :class="'pre_part3_me' + skinNum">{{ item.awardContent }}</p>
        <img :src="item.awardUrl"/>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  props: {
    awardList: {
      type: Array,
      default: () => []
    },
    awardIndex: {
      type: Number,
      default: 1,
    },
    skinNum: {
      type: Number,
      default: 0,
    }
  },
  data () {
    return {
      swiperInfo:"",
      loopImgs: false,
    }
  },
  created(){
    if(this.awardList.length > 3) {
      this.loopImgs = true
    }
  },
  mounted () {
    let that = this
    this.swiper = "";
    this.swiperInfo = new Swiper("#swiper"+ that.awardIndex, {
      direction: "horizontal",
      initialSlide: 1,//默认第二页
      loop : that.loopImgs, //环路，让Swiper看起来是循环的
      speed : 600, //速度
      freeMode : true, //根据惯性滑动可能不止一格且不会贴合
      observer : true, //修改swiper自己或子元素时，自动初始化swiper
      autoplay : that.loopImgs, //自动切换
      // autoplay: false,
      // observer: true,
      observeParents: true,
      effect: "coverflow",
      slidesPerView: "auto",
      centeredSlides: true,
      coverflowEffect: {
        rotate: 0, //slide做3d旋转时Y轴的旋转角度。默认50。
        stretch: -5, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
        depth: 20, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
        modifier: 5,
        slideShadows: false, //开启slide阴影。默认 true。
      },
    });
    // 大于3自动轮播
    /*if(this.awardList.length > 0&&this.awardList.length > 3){
      this.swiperInfo.autoplay = true;
    }*/
  },
  components: {
  },
  methods: {
  }
}
</script> 
<style scoped lang="less">
.part3_mess {
  padding-top: 62px;
  width: 100%;
}
.part3_mess_pre {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  width: 280px;
  height: 314px;
  background: rgba(248, 248, 248);
  border-radius: 10px;
  margin-right: 47px;
  flex-shrink: 0;
  .pre_part3_tit {
    width: 137px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 26px;
    color: #6775ab;
    position: absolute;
    left: 50%;
    top: 11%;
    transform: translate(-50%, 0);
  }
  .pre_part3_me {
    text-align: center;
    padding-top: 29%;
    color: #6775ab;
  }
  img {
    width: 120px;
    height: 154px;
    position: absolute;
    bottom: 33px;
    right: 50%;
    transform: translate(50%, 0);
  }
  .pre_part3_tit1 {
    color: #b362a4;
  }
  .pre_part3_me1 {
    color: #b362a4;
  }
  .pre_part3_tit2 {
    color: #64c69c;
  }
  .pre_part3_me2 {
    color: #64c69c;
  }
}

.swipersBox {
  width: 100%;
  padding-top: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/design/activeList/carouselBox2.vue